import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import "./twb.css";

const Movers = (props) => {
  const { className } = props;

  const [modal, setModal] = useState(false);

  const toggle = () => setModal(!modal);

  const closeBtn = (
    <button className='close' onClick={toggle}>
      &times;
    </button>
  );

  return (
    <div>
      <button className='button' onClick={toggle}>
        See the project
      </button>
      <Modal isOpen={modal} toggle={toggle} className={className}>
        <ModalHeader toggle={toggle} close={closeBtn}>
          Modal title
        </ModalHeader>
        <ModalBody className='modalBody'>
          <img
            src='https://res.cloudinary.com/elijjaaahhhh/image/upload/v1614137511/FireShot_Pro_Webpage_Screenshot_016_-_Multi_Device_Website_Mockup_Generator_-_techsini_com_sf69qw.png'
            alt='img'
          />
          <h2>Movers</h2>
          <div className='tag-body-single'>
            <div className='tags'>Html</div>
            <div className='tags'>Css</div>
            <div className='tags'>Javascript</div>
          </div>
          <p>
            This is the homepage UI of Movers website built with Html, Css and
            Javascript. This website makes it easy for people to transport goods
            within the city. It is currently being rebuilt with React/Redux for
            frontend and Ruby on Rails for backend
          </p>
          <div className='tag-body-live'>
            <div className='tag one'>
              <a
                href='https://eloquent-murdock-ba7a26.netlify.app/'
                target='_blank'
              >
                See live
              </a>
            </div>
            <div className='tag two'>
              <a
                href='https://github.com/Elijahscriptdev/MOVERS'
                target='_blank'
              >
                see code
              </a>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default Movers;
